import MatchedMap from 'utilities/src/matchedMap';
import { TBoxTypeEnum } from '../../shared/utils/types';
import { InputThemeEnum } from '../../shared/utils/themes';

const checkboxInputCheckedThemeClasses = new MatchedMap([
  [InputThemeEnum.Dark, '[&:checked~label>div]:bg-white [&:checked~label>div]:border-white'],
  [
    InputThemeEnum.Light,
    '[&:checked~label>div]:bg-site-neutrals-900 [&:checked~label>div]:border-site-neutrals-900',
  ],
]);

const radioInputCheckedThemeClasses = new MatchedMap([
  [InputThemeEnum.Dark, ''],
  [InputThemeEnum.Light, ''],
]);

const inputThemeClasses = new MatchedMap([
  [TBoxTypeEnum.Checkbox, checkboxInputCheckedThemeClasses],
  [TBoxTypeEnum.Radio, radioInputCheckedThemeClasses],
]);

const checkboxSiteTheme = {
  inputThemeClasses,
};

export default checkboxSiteTheme;
